import { ExpenseReport } from "~/application/types/entities/ExpenseReport.type";
import { ExpenseReportDTO } from "../dtos/expenseReportsDTO";

export function mapExpenseReportDTO(data: ExpenseReportDTO): ExpenseReport {
  return {
    uuid: data.uuid,
    createdAt: data.created_at,
    approvedDate: data.approved_date,
    order: {
      uuid: data.order.uuid,
      orderNumber: data.order.order_number,
      issueDate: data.order.issue_date,
      obs: data.order.obs,
    },
    advanceNumber: data.advance_number,
    costCenter: {
      name: data?.cost_center?.name,
      uuid: data?.cost_center?.uuid,
    },
    traveler: {
      avatarUrl: data.traveler.avatarUrl,
      fullName: data.traveler.full_name,
      company: {
        tradingName: data.traveler.company.trading_name,
      },
      cpf: data.traveler.cpf,
      dateBirth: data.traveler.date_birth,
      email: data.traveler.email,
      rg: data.traveler.rg,
      uuid: data.traveler.uuid,
    },
    issuer: data.issuer,
    description: data.description,
    status: data.status,
    expenses: data.expenses.map((e) => ({
      advanceOrderId: e.advance_order_uuid,
      company: e.company,
      customerEmployeeId: e.customer_employee_uuid,
      deleterId: e.deleter_uuid,
      expenseCategory: e.expense_category,
      expenseDate: e.expense_date,
      expenseType: e.expense_type,
      expenseTypeUuid: e.expense_type_uuid,
      justification: e.justification,
      uuid: e.uuid,
      value: e.value,
      voucherPath: e.voucher_path,
    })),
    expenseTotalValue: data.expense_total_value,
    advanceOrderValue: data.value,
    approvalRequestDate: data.approval_request_date,
    approvalModel: data.approval_model,
    approvedBy: data.approved_by,
  };
}
